import { useMemo } from 'react'
import get from 'lodash/get'
import { shallowEqual, useSelector } from 'react-redux'

import { useTranslations } from 'common/language'
import { Button, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


export default function ExpiredModal() {
  const { gettext, languageCode } = useTranslations()
  const utmTag = useSelector(state => get(state, 'utmData.data.quote_utm_tags.school_finder_link_tags', ''), shallowEqual)
  let value = useMemo(() => `/${languageCode}/school-finder`, [languageCode])
  if(utmTag) {
    value = value + `?${utmTag}`
  }
  return (
    <div>
      <div className={classNames.modalTextBlock}>
        <Typography variant="h3">
          {gettext('This quote has expired')}
        </Typography>
      </div>
      <div className={classNames.modalButtons}>
        <Button to={value}>
          {gettext('Get a new quote')}
        </Button>
      </div>
    </div>
  )
}
